import React, { useEffect, useRef, useState } from 'react'
import { Box, Flex, Textarea, IconButton, Button } from '@chakra-ui/react'
import { ArrowRightIcon } from '@chakra-ui/icons'

import MessageCenterMessageCard from './components/MessageCenterMessageCard'
import MessageCenterHeader from './components/MessageCenterHeader'
import { useMessageCenterChatManager } from './contexts/MessageCenterChatManager/Provider'
import { MessageCenterMessage } from './types'
import { MessageCenterChatContentProps } from '.'
import { CustomDivider } from 'components/miscellaneous'

export default function MessageCenterChatComponent({ currentUser, height = '600px' }: MessageCenterChatContentProps) {
  const [text, setText] = useState('')

  const { messages, setMessages, routes } = useMessageCenterChatManager()

  const endRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' })
  }, [messages])

  const handleSendMessage = async () => {
    const trimmedMessage = text.trim()
    if (!trimmedMessage) return

    const response = await routes?.sendMessage({ message: trimmedMessage })

    if (response?.header?.success) {
      const newMessage = response?.body?.case_chat_message as MessageCenterMessage
      setMessages((previousMessage) => [...previousMessage, newMessage])
      setText('')
    }
  }

  return (
    <Flex
      direction="column"
      bg="bgContent"
      borderRadius="md"
      borderWidth="1px"
      borderColor="borderColor"
      w="100%"
      h={height}
    >
      <MessageCenterHeader currentUser={currentUser} />

      <Box flex="1" overflowY="auto" mb={4} px={2} p={4}>
        {messages.map((message, index) => {
          return <MessageCenterMessageCard key={message.id} message={message} currentUser={currentUser} index={index} />
        })}

        <div ref={endRef} />
      </Box>

      <CustomDivider />

      <Flex
        direction={{ base: 'column', sm: 'column', md: 'row', lg: 'row', xl: 'row', '2xl': 'row' }}
        gap={2}
        p={4}
        align="center"
      >
        <Textarea
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Digite uma mensagem... (Enter para enviar, Shift+Enter para nova linha)"
          resize="vertical"
          minH="44px"
          maxH="160px"
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault()
              handleSendMessage()
            }
          }}
        />

        <IconButton
          size="md"
          display={{ base: 'none', sm: 'none', md: 'block', lg: 'block', xl: 'block', '2xl': 'block' }}
          aria-label="Enviar mensagem"
          icon={<ArrowRightIcon />}
          colorScheme="blue"
          onClick={handleSendMessage}
          isDisabled={!text.trim()}
        />

        <Button
          size="md"
          display={{ base: 'block', sm: 'block', md: 'none', lg: 'none', xl: 'none', '2xl': 'none' }}
          minWidth="100%"
          colorScheme="blue"
          onClick={handleSendMessage}
          isDisabled={!text.trim()}
        >
          Enviar mensagem
        </Button>
      </Flex>
    </Flex>
  )
}
